<template>
  <v-navigation-drawer
    :value="$store.state.ui.openRightNavDrawer"
    :right="true"
    fixed
    enable-resize-watcher
    persistent
    app
  >
    <!-- <v-list>
      <v-list-item>
        <v-list-item-action>
          <v-icon>help</v-icon>
        </v-list-item-action>
        <v-list-item-title>Click for help</v-list-item-title>
      </v-list-item>
    </v-list> -->

    <comments-list :personId="$route.params.id" v-if="$route.params.id">
    </comments-list>

    <referrals-list />
  </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";
import commentsList from "@/components/register/comments/list";
import referralsList from "@/components/register/referrals/list";

export default {
  components: {
    commentsList,
    referralsList
  }
};
</script>
